import React, { useEffect } from 'react';

import { LoadingCircle, Tile } from '../components'
import { testing_or_dummy } from '../globals'


const Regolamento = () => {
  useEffect(() => {
    document.title = "Regolamento - GAS";
  }, [])

  const ANNI = [2027, 2026, 2025, 2024, 2023];

  return (
    <div className="container">
      <h1 className="page-header">Regolamento</h1>
      <p>Qui sotto alleghiamo le regole della competizione, anno per anno, in formato PDF.</p>
      {ANNI.map(year => {

        const regolamento = testing_or_dummy(`regolamento-${year}`);
        const istruzioni = testing_or_dummy(`istruzioni-${year}`);
        if (!regolamento || !istruzioni) {
          return <LoadingCircle />
        }
        const poli = testing_or_dummy(`poli-${year}`);
        return (
          <React.Fragment key={year}>
            <h1>{year}</h1>
            <div className="d-flex flex-wrap justify-content-center">
              <Tile
                url={regolamento}
                absolute={true}
                color="info" text={`Regolamento ${year}`}
                icon="fa-balance-scale"
              />
              <Tile
                url={istruzioni}
                absolute={true}
                color="wet-asphalt" text={`Logistica ${year}`}
                icon="fa-cogs"
              />
              {!!poli &&
                <Tile
                  url={poli}
                  absolute={true}
                  color="belize-hole" text={`Poli locali ${year}`}
                  icon="fa-flag"
                />
              }
            </div>
          </React.Fragment>
        )
      })}

    </div>
  );
}

export default Regolamento;
